<template>
    <div>
        <div class="modal fade" id="newSiteModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">New Netlify Site</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="row mb-3">
                                <label for="nameInput" class="col-sm-3 col-form-label">Name</label>
                                <div class="col-sm-9">
                                    <input id="nameInput" type="text" class="form-control" placeholder="site name"
                                           v-model="site.name">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">Yes</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import IntegrationsService from "../services/IntegrationsService";

    export default {
        name: 'NewNetlifySiteModal',
        props: {
            yesEvent: Function,
            integration: Object
        },
        data () {
            return {
                model: webase.model,
                site: {
                    name: ''
                },
                service: new IntegrationsService(),
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('newSiteModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()

            if(this.model.website) {
                this.site.name = this.model.website.name
            }

        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {

                if(this.site.name) {
                    let request = {
                        integration: {
                            command: 'new site',
                            name: this.site.name
                        }
                    }

                    this.model.loading = true

                    this.service.executeCommand(this.integration.slug, request).then((netlifySite) => {
                        this.model.loading = false
                        console.log('site created')
                        console.log(netlifySite)
                        webase.utils.notification.success('Netlify site created')

                        this.service.listByApp(this.model.app.id).then((response) => {
                            console.log('integrations updating')
                            console.log(response)
                            this.model.app.integrations = response

                            // call the parent's "yesEvent"
                            if(this.yesEvent) {
                                this.yesEvent(netlifySite)
                            }
                        })

                        // hide the modal
                        this.noHandler()

                    }).catch((message) => {
                        this.model.loading = false
                        console.log('error creating site')
                        console.log(message)
                        webase.utils.notification.error(message)
                    })
                }


            }
        }
    }
</script>

